<template>
	<app-content style="position: relative;">
		<div class="mask" v-if="User.role =='View' || isLocked"></div>
		<div class="h-panel" style="width: 1000px;margin: 0 auto;padding-top: 20px;">
			<img v-if="form.auditMemberId" class="auditpic" src="@/assets/audit.png" alt="已审核">
			<div class="padding-right-left">
				<Row type="flex" :space-x="10">
					<Cell v-if="User.role !='View'">
						<template v-if="isCheck">
							<Button v-if="isCheck" @click="$router.back()">返回</Button>
							<Button :disabled="!canSave" color="primary" @click="save(true)" :loading="loading">保存</Button>
						</template>
						<template v-else>
							<Button :disabled="!canSave" color="primary" @click="save(true)" :loading="loading" v-if="!form.id">保存并新增</Button>
							<Button :disabled="!!form.auditMemberId" color="primary" @click="toNew()" v-else>新增</Button>
							<Button :disabled="!canSave || isLocked" color="primary" @click="save(false)" :loading="loading">保存</Button>
							<Button :disabled="isLocked" color="warning" @click="saveDraft(false)" :loading="loading" v-tooltip content="不校验借贷平衡，稍后可继续编辑">保存草稿</Button>
							<template v-if="form.id && currentAccountSets.voucherReviewed && voucher.status !== 1">
							<Button v-if="form.auditMemberId" color="primary" @click="cancelAudit" :loading="loading">取消审核</Button>
							<Button v-else color="primary" @click="audit" :loading="loading">审核</Button>
						</template>
						<template v-if="form.id && voucher.status !== 1">
							<Button v-if="voucher.cashierSignId" color="primary" @click="cancelSign('cashier')" :loading="loading">取消出纳签字</Button>
							<Button v-else-if="canSignCashier" color="primary" @click="doSign('cashier')" :loading="loading">出纳签字</Button>
							<Button v-if="voucher.supervisorSignId" color="primary" @click="cancelSign('supervisor')" :loading="loading">取消主管签章</Button>
							<Button v-else-if="canSignSupervisor" :disabled="!form.auditMemberId" color="primary" @click="doSign('supervisor')" :loading="loading" v-tooltip content="凭证审核后方可主管签章">主管签章</Button>
						</template>
						<template v-if="form.id && voucher.status === 1">
							<span class="tag" style="background:#f56c6c;color:#fff;vertical-align:middle;">此凭证已作废</span>
						</template>
						<template v-if="form.id && voucher.draft === 1">
							<span class="tag" style="background:#e6a23c;color:#fff;vertical-align:middle;">草稿凭证（保存后转正）</span>
						</template>
						</template>
					</Cell>
					<Cell v-if="!isCheck">
						<a class="h-btn" :href="`/api/pfd/voucher?id=${form.id}`" target="_blank">打印</a>
					</Cell>
					<template v-if="!isCheck && User.role !='View'">
						<Cell><Button @click="showShortcut = true">快捷键</Button></Cell>
						<Cell><Button @click="openTplModal('load')">模板</Button></Cell>
						<Cell><Button @click="clearTable">清除</Button></Cell>
						<Cell v-if="form.id && !isLocked"><Button @click="delVoucher">删除</Button></Cell>
					</template>
					<Cell :flex="1" class="text-right" v-if="!isCheck">
						<ButtonGroup>
							<Button :loading="loading" @click="before" size="s" v-tooltip content="上一条" icon="h-icon-left"></Button>
							<Button :loading="loading" @click="next" size="s" v-tooltip content="下一条" icon="h-icon-right"></Button>
						</ButtonGroup>
					</Cell>
				</Row>
				<Row class="margin-top" type="flex" :space-x="10">
					<Cell>
						<Select @change="loadCode" keyName="word" titleName="word" style="min-width: 70px" :deletable="false" :datas="voucherWords" v-model="form.word" placeholder="记"/>
					</Cell>
					<Cell class="label">
						<NumberInput :min="1" v-model="form.code" v-width="90" style="display: inline-block"/>
						号
					</Cell>
					<Cell class="label">
						日期：
					</Cell>
					<Cell class="label">
					<DatePicker :disabled="!!carryForward" :option="dpOps" :clearable="false" v-model="form.voucherDate" format="YYYY-MM-DD"/>
				</Cell>
				<Cell class="label shortcut-hint" v-if="!isCheck">按回车键或Tab键能快速选择单元格</Cell>
				<template v-if="currencies.length">
					<Cell class="label">
						币别：
					</Cell>
					<Cell class="label">
						<Select keyName="id" titleName="code" style="min-width: 90px" :allow-blank="true" :datas="currencies" v-model="form.currencyId" @change="changeCurrency"/>
					</Cell>
					<Cell class="label" v-if="form.currencyId">
						汇率：
					</Cell>
					<Cell class="label" v-if="form.currencyId">
						<NumberInput :min="0" v-model="form.exchangeRate" v-width="90" style="display: inline-block"/>
					</Cell>
				</template>
					<Cell class="label">
					<DropdownCustom :toggle-icon="false" class-name="h-text-dropdown">
						<span class="text-hover blue-color font-bold">备注</span>
						<div slot="content" v-width="200">
							<textarea placeholder="请输入备注内容" v-model="form.remark" v-autosize rows="3" style="width: 100%;"></textarea>
						</div>
					</DropdownCustom>
				</Cell>
				<Cell class="label" v-if="!isCheck">
					<DropdownCustom :toggle-icon="false" placement="bottom-end" class-name="att-dropdown">
						<span class="fjd-inline">
							附单据
							<input class="fjd-count" :value="attachments.length" readonly>
							张
							<i class="fa fa-paperclip fjd-clip" :class="{'has-att': attachments.length}"></i>
						</span>
						<div slot="content" class="att-panel" v-width="300">
							<div class="att-panel-head">
								<span>附件列表</span>
								<span class="att-upload" @click="panelUpload" v-if="canEditAttachments"><i class="fa fa-upload"></i> 点击上传</span>
							</div>
							<ul class="att-panel-list">
								<li v-for="(a, index) in attachments" :key="index">
									<span class="att-name" @click="previewAttachment(form.id, index, a.name)">{{a.name}}</span>
									<span class="att-size">{{(a.size/1024).toFixed(0)}}KB</span>
									<i v-if="canEditAttachments" class="fa fa-trash-o" @click="removeAttachment(index)"></i>
								</li>
								<li v-if="!attachments.length" class="att-empty">暂无数据</li>
							</ul>
							<div class="att-panel-foot" v-if="attachments.length">
								<span class="text-hover" @click="openAttachment">管理全部附件</span>
							</div>
						</div>
					</DropdownCustom>
					<input ref="attachmentFile" type="file" accept=".jpg,.jpeg,.png,.gif,.pdf" multiple style="display: none" @change="attachmentFileChange($event)">
				</Cell>
				</Row>
			</div>
			<voucher-table ref="voucherTable" v-model="voucherTable" :currency-id="form.currencyId" :exchange-rate="form.exchangeRate"/>
			<div class="padding-right-left padding-bottom voucher-footer">
			<div class="footer-info">
				制单人：{{User.realName}}
				<template v-if="voucher.cashierSignName">　　出纳签字：<span class="blue-color">{{voucher.cashierSignName}}</span>（{{formatTime(voucher.cashierSignDate, 'YYYY-MM-DD')}}）</template>
				<template v-if="voucher.supervisorSignName">　　主管签章：<span class="blue-color">{{voucher.supervisorSignName}}</span>（{{formatTime(voucher.supervisorSignDate, 'YYYY-MM-DD')}}）</template>
				<template v-if="voucher.auditMemberName">　　审核人：{{voucher.auditMemberName}}</template>
				<template v-if="voucher.auditRemark && !voucher.auditMemberId">　　<span class="red-color font-bold">{{voucher.auditRemark}}</span></template>
				<template v-if="voucher.auditRemark && voucher.auditMemberId">　　审核批注：{{voucher.auditRemark}}</template>
			</div>
			<div class="footer-actions" v-if="!isCheck && User.role!=='View'">
				<Button :disabled="!canSave" color="primary" @click="save(true)" v-if="!form.id">保存并新增</Button>
				<Button :disabled="!!form.auditMemberId" color="primary" @click="toNew()" v-else>新增</Button>
				<Button :disabled="!canSave || isLocked" color="primary" @click="save(false)">保存</Button>
				<Button :disabled="isLocked" @click="clearTable">清除</Button>
			</div>
		</div>
		</div>
		<Modal v-model="showShortcut" :closeOnMask="true">
			<div slot="header">凭证快捷键</div>
			<table class="h-table shortcut-table">
				<tr><td>F1</td><td>打开快捷键目录</td><td>Enter / Tab</td><td>跳转单元格或换行</td></tr>
				<tr><td>Ctrl + S</td><td>保存</td><td>↑ / ↓</td><td>上一行 / 下一行</td></tr>
				<tr><td>Alt + N</td><td>新增凭证</td><td>空格</td><td>金额换方向</td></tr>
				<tr><td>Ctrl + Q</td><td>从凭证模板引入</td><td>=</td><td>金额自动平衡</td></tr>
				<tr><td>Ctrl + P</td><td>打印凭证</td><td>Ctrl + =</td><td>新增一行</td></tr>
				<tr><td>Ctrl + Delete</td><td>删除当前凭证</td><td></td><td></td></tr>
			</table>
			<div slot="footer"><Button @click="showShortcut = false">关闭</Button></div>
		</Modal>
		<Modal v-model="tplModal.show" :closeOnMask="true">
			<div slot="header">凭证模板</div>
			<Tabs v-model="tplModal.tab" :datas="[{title:'从模板加载',key:'load'},{title:'保存为模板',key:'save'}]"></Tabs>
			<div v-if="tplModal.tab==='load'" class="tpl-pane">
				<input type="text" class="h-input" v-model="tplModal.keyword" placeholder="搜索模板名称..."/>
				<ul class="tpl-list">
					<li v-for="t in filteredTplList" :key="t.id">
						<span class="tpl-name text-hover" @click="applyTpl(t)">{{t.name}}</span>
						<span class="dark4-color">借 {{t.debitAmount|numFormat}} / 贷 {{t.creditAmount|numFormat}}</span>
						<i class="fa fa-trash-o" v-tooltip content="删除模板" @click="removeTpl(t)"></i>
					</li>
					<li v-if="!filteredTplList.length" class="empty">暂无凭证模板</li>
				</ul>
			</div>
			<div v-else class="tpl-pane">
				<Row type="flex" :space-x="10">
					<Cell :flex="1"><input type="text" class="h-input" v-model="tplModal.name" placeholder="请输入模板名称" @keyup.enter="saveAsTpl"/></Cell>
					<Cell><Button color="primary" @click="saveAsTpl" :loading="tplModal.saving">保存</Button></Cell>
				</Row>
			</div>
			<div slot="footer"><Button @click="tplModal.show = false">关闭</Button></div>
		</Modal>
		<Modal v-model="attachmentModal.show" :width="600" :closeOnMask="false">
			<div slot="header">凭证附件【{{form.word}}-{{form.code}}】</div>
			<table class="h-table">
				<tr>
					<th>文件名</th>
					<th style="width: 90px">大小</th>
					<th style="width: 80px">上传人</th>
					<th style="width: 150px">上传时间</th>
					<th style="width: 60px">操作</th>
				</tr>
				<tr v-for="(a, index) in attachmentModal.list" :key="index">
					<td><span class="text-hover" @click="previewAttachment(form.id, index, a.name)">{{a.name}}</span></td>
					<td>{{(a.size / 1024).toFixed(1)}} KB</td>
					<td>{{a.createMember}}</td>
					<td>{{formatTime(a.createTime)}}</td>
					<td><span v-if="User.role!=='View' && !isLocked" class="text-hover red-color" @click="removeAttachment(index)">删除</span></td>
				</tr>
				<tr v-if="!attachmentModal.list.length">
					<td colspan="5" class="text-center padding">暂无附件，点击右下角"上传附件"添加单据图片或 PDF</td>
				</tr>
			</table>
			<div class="dark4-color" style="margin-top: 8px;">共 {{attachmentModal.list.length}} 个附件，合计 {{attachmentTotalSize}} KB。图片附件点击可放大预览，PDF 将在新窗口打开</div>
			<div slot="footer">
				<Button @click="attachmentModal.show = false">关闭</Button>
				<Button v-if="User.role!=='View' && !isLocked" color="primary" :loading="attachmentModal.uploading" @click="panelUpload">上传附件</Button>
			</div>
		</Modal>
		<Modal v-model="previewModal.show" :closeOnMask="true">
			<div slot="header">附件预览 - {{previewModal.name}}</div>
			<div class="text-center">
				<img :src="previewModal.src" style="max-width: 100%; max-height: 65vh;" :alt="previewModal.name"/>
			</div>
			<div slot="footer">
				<Button color="primary" @click="previewModal.show = false">关闭</Button>
			</div>
		</Modal>
		<Modal v-model="auditModal.show" :closeOnMask="false" :width="420">
			<div slot="header">审核确认</div>
			<p>亲，确认要审核本张凭证吗?</p>
			<div class="margin-top">
				<textarea class="h-input" rows="3" style="width: 100%;" v-model="auditModal.remark" placeholder="审核批注（可选）"></textarea>
			</div>
			<div slot="footer">
				<Button @click="auditModal.show = false">取消</Button>
				<Button :loading="loading" @click="doReject" style="background:#f56c6c;color:#fff;">驳回</Button>
				<Button color="primary" :loading="loading" @click="doAudit">确认审核</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import VoucherTable from "../../components/VoucherTable";
	import {mapState} from 'vuex';
	import moment from 'moment';

	export default {
		name: "VoucherForm",
		components: {VoucherTable},
		inject: ['reload'],
		props: {
			voucherId: [Number, String],
		},
		computed: {
			...mapState(['User', 'currentAccountSets']),
			voucherItems() {
				return this.voucherTable.voucherItems;
			},
			canSave() {
				return this.voucherItems.length > 0
			},
			isCheck() {
				return !!this.$route.params.checkData
			},
			isSigned() {
				return !!(this.voucher.cashierSignId || this.voucher.supervisorSignId);
			},
			isLocked() {
				return this.form.auditMemberId || this.isSigned || this.voucher.status === 1;
			},
			canSignCashier() {
				return ['Cashier', 'BOSS'].includes(this.User.role) && this.voucher.draft !== 1;
			},
			canSignSupervisor() {
				return ['Director', 'Manager', 'BOSS'].includes(this.User.role) && this.voucher.draft !== 1;
			},
			attachments() {
				if (!this.voucher.billList) return [];
				try {
					return JSON.parse(this.voucher.billList) || [];
				} catch (e) {
					return [];
				}
			},
			attachmentTotalSize() {
			let total = 0;
			this.attachmentModal.list.forEach(a => total += Number(a.size) || 0);
			return (total / 1024).toFixed(1);
		},
		canEditAttachments() {
			return this.User.role !== 'View' && !this.isLocked && !this.isCheck;
		},
			filteredTplList() {
				if (this.tplModal.keyword) {
					return this.tplList.filter(t => t.name && t.name.indexOf(this.tplModal.keyword) !== -1);
				}
				return this.tplList;
			}
		},
		data() {
			return {
				loading: false,
				carryForward: false,
				voucherWords: [],
			currencies: [],
			rateList: [],
			voucherTable: {voucherItems: []},
				showShortcut: false,
				tplModal: {show: false, tab: 'load', keyword: '', name: '', saving: false},
				tplList: [],
				attachmentModal: {show: false, list: [], uploading: false},
				previewModal: {show: false, name: '', src: ''},
				auditModal: {show: false, remark: ''},
				draftTimer: null,
				fixedCode: null,
				dpOps: {
					start: moment().toDate()
				},
				voucher: {},
				form: {
					remark: '',
					word: '',
					code: '',
					voucherDate: '',
					carryForward: false,
				}
			}
		},
		watch: {
			'form.word'(val, old) {
				if (!old && this.voucherId) {
					return;
				}
				val && this.loadCode();
			},
			voucherItems: {
				handler() {
					this.scheduleDraftSave();
				},
				deep: true
			},
			voucherId(val) {
				if (!val) {
					this.reload()
				} else {
					this.init();
				}
			}
		},
		beforeRouteLeave(to, from, next) {
			next();
		},
		methods: {
			loadVoucherWords() {
			this.$api.setting.voucherWord.list().then(({data}) => {
				this.voucherWords = data || [];
				if (!this.form.word && this.voucherWords.length) {
					let def = this.voucherWords.find(value => value.isDefault) || this.voucherWords[0];
					this.form.word = def.word;
				}
			})
		},
		loadCurrencies() {
			this.$api.setting.currency.list().then(({data}) => {
				//本位币不作为外币选项
				this.currencies = (data || []).filter(c => c.id && !c.localCurrency);
			});
			this.$api.setting.exchangeRate.list().then(({data}) => {
				this.rateList = data || [];
			});
		},
		changeCurrency() {
			if (!this.form.currencyId) {
				this.form.exchangeRate = null;
				return;
			}
			//按凭证日期所在期间自动带出已维护汇率
			let d = this.form.voucherDate ? moment(this.form.voucherDate) : moment();
			let hit = this.rateList.find(r => r.currencyId === this.form.currencyId && r.year === d.year() && r.month === (d.month() + 1));
			if (hit) {
				this.form.exchangeRate = hit.rate;
			} else {
				//未维护期间汇率时，取币别设置中的默认汇率兜底（可手工修改），不再静默按 1 折算
				let cur = this.currencies.find(c => c.id === this.form.currencyId);
				this.form.exchangeRate = cur && cur.exchangeRate > 0 ? cur.exchangeRate : null;
				this.$Message('该币别当前期间未维护汇率，已带出币别默认汇率，请确认后保存；也可先在「设置-期间汇率」中设置');
			}
		},
			loadCode() {
				this.$api.voucher.loadCode({
					word: this.form.word,
					currentAccountDate: this.form.voucherDate
				}).then(({data}) => {
					this.form.code = this.fixedCode || data;
					this.fixedCode = null;
				})
			},
			toNew() {
				this.$router.push({name: 'VoucherForm'});
			},
			save(next) {
				if (!this.form.code) {
					this.$Message("亲，请输入编号！");
					return
				}

				if (!this.voucherItems.length) {
					this.$Message("亲，第1行不能为空！");
					return
				}

				if (this.checkItem("摘要", 'summary') || this.checkItem("科目", 'subjectId') || this.checkItem("金额")) {
					return
				}

				if (this.voucherTable.jfTotal != this.voucherTable.dfTotal) {
					this.$Message("亲，借贷不平衡！");
					return
				}

				//政府会计平行记账：含预算分录时，财务会计与预算会计须各自借贷平衡
				if (Number(this.currentAccountSets.accountingStandards) === 7 && this.voucherTable.hasBudgetEntry) {
					if (Math.round(Number(this.voucherTable.budgetJfTotal || 0) * 100) !== Math.round(Number(this.voucherTable.budgetDfTotal || 0) * 100)) {
						this.$Message("预算会计分录借贷不平衡！");
						return
					}
					let finJfFen = Math.round(Number(this.voucherTable.jfTotal || 0) * 100) - Math.round(Number(this.voucherTable.budgetJfTotal || 0) * 100);
					let finDfFen = Math.round(Number(this.voucherTable.dfTotal || 0) * 100) - Math.round(Number(this.voucherTable.budgetDfTotal || 0) * 100);
					if (finJfFen !== finDfFen) {
						this.$Message("财务会计分录借贷不平衡！");
						return
					}
				}

				this.loading = true;
				this.$api.voucher[this.voucherId ? 'update' : 'save'](Object.assign({}, this.form, {details: this.voucherItems, createMember: this.User.id})).then(({success, data, msg}) => {
					if (success && !this.form.id) {
						if (next) {
							if (!this.isCheck) {
								this.reload();
							} else {
								this.$router.back();
							}
						} else {
							this.$router.push({name: 'VoucherForm', params: {voucherId: data.id}});
						}
					}

					this.loading = false;
					this.clearDraft();
					this.$Message(msg ? msg : "亲，保存成功！");

					//如果是结转凭证就返回
					if (this.$route.params.checkData) {
						this.$router.back();
					}
				}).catch(() => {
					this.loading = false;
				});
			},
			saveDraft() {
				if (!this.form.code) {
					this.$Message("亲，请输入编号！");
					return
				}
				this.loading = true;
				this.$api.voucher[this.voucherId ? 'update' : 'save'](Object.assign({}, this.form, {
					details: this.voucherItems,
					createMember: this.User.id,
					draft: 1
				})).then(({success, data, msg}) => {
					this.clearDraft();
					this.$Message(msg ? msg : "草稿已保存");
					if (!this.form.id && success) {
						this.$router.push({name: 'VoucherForm', params: {voucherId: data.id}});
					} else {
						this.loading = false;
					}
				}).catch(() => {
					this.loading = false;
				});
			},
			checkItem(name, field) {
				let i = 0, len = this.voucherItems.length, row = -1;
				for (; i < len; i++) {
					if ((field && !this.voucherItems[i][field]) || (!field && !this.voucherItems[i].debitAmount && !this.voucherItems[i].creditAmount)) {
						row = i + 1;
						break;
					}
				}

				if (row > -1) {
					this.$Message(`亲，第${row}行，请输入${name}！`);
					return true;
				}
			},
			before() {
				this.loading = true;
				this.$api.voucher.beforeId({currentId: this.voucherId}).then(({data}) => {
					if (data) {
						this.$router.push({name: 'VoucherForm', params: {voucherId: data}})
					} else {
						this.$Message("亲，已经没有上一条啦！")
					}
				}).finally(() => {
					this.loading = false;
				});
			},
			next() {
				this.loading = true;
				this.$api.voucher.nextId({currentId: this.voucherId}).then(({data}) => {
					if (data) {
						this.$router.push({name: 'VoucherForm', params: {voucherId: data}})
					} else {
						this.$Message("亲，已经没有下一条啦！")
					}
				}).finally(() => {
					this.loading = false;
				});
			},
			init() {
				if (this.voucherId) {
					this.$api.voucher.load(this.voucherId).then(({data}) => {
						this.$refs.voucherTable.initValue(data.details);
						this.voucher = data;
						this.form = {
						id: data.id,
						auditMemberId: data.auditMemberId,
						word: data.word,
						remark: data.remark,
						voucherDate: data.voucherDate,
						carryForward: data.carryForward,
						code: data.code,
						currencyId: data.currencyId,
						exchangeRate: data.exchangeRate
					};
					})
				} else {
					this.form.voucherDate = moment(this.currentAccountSets.currentAccountDate).endOf('month').format('YYYY-MM-DD');
				}

				//结转凭证初始化
				let params = this.$route.params;

				//复制/红冲初始化
				if (params.copyData) {
					let v = params.copyData;
					this.form.word = v.word;
					this.$nextTick(() => {
						this.$refs.voucherTable.initValue(v.details);
					});
				}

				//插入初始化（凭证号已被后端后移，此处占用空出的号）
				if (params.insertData) {
					this.fixedCode = params.insertData.code;
					this.form.word = params.insertData.word;
				}

				if (params.checkData) {
					this.carryForward = !!params.type.code;
					this.form.voucherDate = moment(params.checkData.checkYear + "-" + params.checkData.checkMonth).endOf('month').format('YYYY-MM-DD');
					let {subject, name} = params.type;
					let details = [];
					this.$api.setting.subject.loadByCode(subject, Object.assign(params.checkData, {name})).then(({data}) => {
						let creditAmount = 0, debitAmount = 0;
						data.subject.forEach(sub => {
							let amount = data.amount[sub.code];
							let detail = {
								summary: `第${params.checkData.checkMonth}期 ${name}`,
								subject: sub,
								subjectId: sub.id,
								subjectName: `${sub.code}-${sub.name}`,
								subjectCode: sub.code
							};
							if (amount) {
								if (amount.creditAmount) {
									details.push(Object.assign({}, detail, {[name === '结转损益' ? 'debitAmount' : 'creditAmount']: amount.creditAmount}));
									creditAmount += amount.creditAmount;
								}

								if (amount.debitAmount) {
									details.push(Object.assign({}, detail, {[name === '结转损益' ? 'creditAmount' : 'debitAmount']: amount.debitAmount}));
									debitAmount += amount.debitAmount;
								}
							} else if (name !== '结转损益' || sub.name === '本年利润') {
								details.push(detail);
							}
						});

						if (name === '结转损益') {
							this.form.carryForward = true;
							let zeroProfitIndex = -1;
							details.forEach((value, index) => {
								if (value.subject.name === '本年利润') {
									delete value.debitAmount;
									let amount = debitAmount - creditAmount;
									if (amount > 0) {
										value.debitAmount = amount;
									} else if (amount < 0) {
										value.creditAmount = Math.abs(amount);
									} else {
										//本期收入与费用恰好相等，借贷已平衡，无需本年利润轧差行（0金额行后端会拦截）
										zeroProfitIndex = index;
									}
								}
							});
							if (zeroProfitIndex >= 0) {
								details.splice(zeroProfitIndex, 1);
							}
						}

						this.$refs.voucherTable.initValue(details);
					});
				}
				//纯新增场景检测未保存草稿
				if (!this.voucherId && !params.copyData && !params.insertData && !params.checkData) {
					this.restoreDraft();
				}
				this.loadVoucherWords();
			this.loadCurrencies();
		},
		audit() {
				this.auditModal.remark = '';
				this.auditModal.show = true;
			},
			doAudit() {
				this.loading = true;
				this.$api.voucher.audit({checked: [this.voucher.id], year: this.voucher.voucherYear, month: this.voucher.voucherMonth, remark: this.auditModal.remark}).then(() => {
					this.auditModal.show = false;
					this.$Message("审核成功！");
					//自动跳转下一张未审核凭证
					this.$api.voucher.nextUnauditedId({currentId: this.voucher.id}).then(({data}) => {
						if (data) {
							this.$router.push({name: 'VoucherForm', params: {voucherId: data}});
						} else {
							this.reload();
						}
					}).catch(() => {
						this.reload();
					});
				}).finally(() => {
					this.loading = false;
				});
			},
			doReject() {
				let reason = (this.auditModal.remark || '').trim();
				if (!reason) {
					this.$Message('请填写驳回原因');
					return;
				}
				this.loading = true;
				this.$api.voucher.reject({voucherId: this.voucher.id, reason}).then(() => {
					this.auditModal.show = false;
					this.$Message('已驳回，等待制单人修改');
					this.reload();
				}).finally(() => {
					this.loading = false;
				});
			},
			doSign(type) {
				this.$Confirm(type === 'cashier' ? "确认以出纳身份签字吗?" : "确认以主管身份签章吗?").then(() => {
					this.loading = true;
					this.$api.voucher.sign({voucherId: this.voucher.id, type, cancel: false}).then(() => {
						this.reload();
						this.$Message("签章成功！");
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			cancelSign(type) {
				this.$Confirm(type === 'cashier' ? "确认取消出纳签字吗?" : "确认取消主管签章吗?").then(() => {
					this.loading = true;
					this.$api.voucher.sign({voucherId: this.voucher.id, type, cancel: true}).then(() => {
						this.reload();
						this.$Message("取消签章成功！");
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			openAttachment() {
				this.attachmentModal.list = this.attachments;
				this.attachmentModal.show = true;
			},
			panelUpload() {
			if (!this.form.id) {
				this.$Message('请先保存凭证后再上传附件');
				return;
			}
			this.$refs.attachmentFile.click();
		},
			attachmentFileChange(e) {
				let files = Array.from(e.target.files);
				if (!files.length) return;
				for (let f of files) {
					if (f.size > 10 * 1024 * 1024) {
						this.$Message.error(`文件 ${f.name} 超过10MB`);
						e.target.value = '';
						return;
					}
				}
				let formData = new FormData();
				files.forEach(f => formData.append('file', f));
				this.attachmentModal.uploading = true;
				this.$api.voucher.uploadAttachment(this.form.id, formData).then(({data}) => {
					this.attachmentModal.list = data || [];
					this.voucher.billList = JSON.stringify(data || []);
					this.$Message(`成功上传 ${files.length} 个附件`);
				}).finally(() => {
					this.attachmentModal.uploading = false;
					e.target.value = '';
				});
			},
			removeAttachment(index) {
				this.$Confirm('确认删除该附件?').then(() => {
					this.$api.voucher.deleteAttachment(this.form.id, index).then(({data}) => {
						this.attachmentModal.list = data || [];
						this.voucher.billList = JSON.stringify(data || []);
						this.$Message('删除成功');
					});
				});
			},
			isImage(name) {
				return /\.(jpg|jpeg|png|gif)$/i.test(name || '');
			},
			previewAttachment(voucherId, index, name) {
				if (this.isImage(name)) {
					this.previewModal.name = name || '';
					this.previewModal.src = this.$api.voucher.attachmentUrl(voucherId, index);
					this.previewModal.show = true;
				} else {
					window.open(this.$api.voucher.attachmentUrl(voucherId, index), '_blank');
				}
			},
			scheduleDraftSave() {
				if (this.voucherId || this.form.id || this.isCheck || this.User.role === 'View') return;
				if (this.draftTimer) clearTimeout(this.draftTimer);
				this.draftTimer = setTimeout(() => {
					this.saveLocalDraft();
				}, 2000);
			},
			saveLocalDraft() {
				try {
					let items = this.voucherItems.filter(d => d.summary || d.subjectId || d.debitAmount || d.creditAmount);
					if (!items.length) {
						this.clearDraft();
						return;
					}
					localStorage.setItem(this.draftKey(), JSON.stringify({
						form: {word: this.form.word, code: this.form.code, voucherDate: this.form.voucherDate, remark: this.form.remark},
						items: JSON.parse(JSON.stringify(items)),
						time: Date.now()
					}));
				} catch (e) {}
			},
			draftKey() {
				return 'voucherDraft_' + this.currentAccountSets.id;
			},
			clearDraft() {
				try {
					localStorage.removeItem(this.draftKey());
				} catch (e) {}
			},
			restoreDraft() {
				let draft = null;
				try {
					draft = JSON.parse(localStorage.getItem(this.draftKey()));
				} catch (e) {}
				if (!draft || !draft.items || !draft.items.length) {
					return;
				}
				let span = Date.now() - (draft.time || 0);
				let desc = span >= 3600000 ? Math.floor(span / 3600000) + ' 小时' : Math.max(1, Math.round(span / 60000)) + ' 分钟';
				this.$Confirm(`检测到 ${desc}前未保存的录入草稿，是否恢复？`).then(() => {
					if (this.form.word !== draft.form.word) {
						this.fixedCode = draft.form.code;
						this.form.word = draft.form.word;
					} else {
						this.form.code = draft.form.code;
					}
					this.form.voucherDate = draft.form.voucherDate;
					this.form.remark = draft.form.remark || '';
					this.$refs.voucherTable.initValue(draft.items);
					this.$Message('草稿已恢复');
				}).catch(() => {
					this.clearDraft();
				});
			},
			formatTime(t, fmt) {
				return t ? moment(t).format(fmt || 'YYYY-MM-DD HH:mm:ss') : '';
			},
			cancelAudit() {
				this.$Confirm("亲，确认要取消审核吗?").then(() => {
					this.loading = true;
					this.$api.voucher.cancelAudit({checked: [this.voucher.id], year: this.voucher.voucherYear, month: this.voucher.voucherMonth}).then(() => {
						this.reload();
						this.$Message("取消审核成功！");
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			clearTable() {
				this.$Confirm("确认要清除吗?").then(() => {
					this.$refs.voucherTable.clear();
				});
			},
			delVoucher() {
				if (!this.form.id) {
					return;
				}
				this.$Confirm("确认要删除吗?").then(() => {
					this.loading = true;
					this.$api.voucher.delete(this.form.id).then(() => {
						this.$Message("删除成功");
						this.$router.push({name: 'VoucherForm'});
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			openTplModal(tab) {
				this.tplModal.show = true;
				this.tplModal.tab = tab || 'load';
				this.tplModal.keyword = '';
				this.tplModal.name = '';
				this.loadTplList();
			},
			loadTplList() {
				this.$api.setting.voucherTemplate.list().then(({data}) => {
					this.tplList = data || [];
				});
			},
			applyTpl(t) {
				this.$api.setting.voucherTemplate.load(t.id).then(({data}) => {
					if (data && data.details && data.details.length) {
						this.$refs.voucherTable.initValue(data.details);
						this.tplModal.show = false;
						this.$Message("模板加载成功");
					} else {
						this.$Message("该模板暂无明细数据");
					}
				});
			},
			removeTpl(t) {
				this.$Confirm("确定要删除该凭证模板吗?").then(() => {
					this.$api.setting.voucherTemplate.delete(t.id).then(() => {
						this.$Message("删除成功");
						this.loadTplList();
					});
				});
			},
			saveAsTpl() {
				let name = (this.tplModal.name || '').trim();
				if (!name) {
					this.$Message("请输入模板名称");
					return;
				}
				if (!this.voucherItems.length) {
					this.$Message("请输入凭证明细");
					return;
				}
				this.tplModal.saving = true;
				this.$api.setting.voucherTemplate.save({name, type: 0, details: this.voucherItems}).then(() => {
					this.$Message("模板保存成功");
					this.tplModal.show = false;
				}).finally(() => {
					this.tplModal.saving = false;
				});
			},
			onKeydown(e) {
				if (this.isCheck) {
					return;
				}
				if (e.key === 'F1') {
					e.preventDefault();
					this.showShortcut = true;
					return;
				}
				if (e.altKey && (e.key || '').toLowerCase() === 'n') {
					e.preventDefault();
					if (this.User.role !== 'View') {
						this.toNew();
					}
					return;
				}
				if (e.ctrlKey || e.metaKey) {
					let k = (e.key || '').toLowerCase();
					if (k === 's') {
						e.preventDefault();
						if (this.canSave && !this.form.auditMemberId && this.User.role !== 'View') {
							this.save(false);
						}
					} else if (k === 'q') {
						e.preventDefault();
						if (this.User.role !== 'View') {
							this.openTplModal('load');
						}
					} else if (k === 'p') {
						if (this.form.id) {
							e.preventDefault();
							window.open(`/api/pfd/voucher?id=${this.form.id}`);
						}
					} else if (k === 'delete') {
						e.preventDefault();
						if (this.form.id && !this.form.auditMemberId && this.User.role !== 'View') {
							this.delVoucher();
						}
					} else if (e.key === '=' || e.code === 'NumpadAdd' || e.key === '+') {
						e.preventDefault();
						this.$refs.voucherTable.addItem(this.$refs.voucherTable.details.length);
					}
				}
			}
		},
		mounted() {
			this.$set(this.dpOps, "start", moment(this.currentAccountSets.enableDate).toDate());
			this.init();
			window.addEventListener('keydown', this.onKeydown);
		},
		beforeDestroy() {
			window.removeEventListener('keydown', this.onKeydown);
			if (this.draftTimer) clearTimeout(this.draftTimer);
		}
	}
</script>

<style scoped>
	.mask {
		position: absolute;
		height: 100%;
		width: 100%;
		z-index: 100;
		bottom: 0;
		top: 110px;
	}

	.auditpic {
		position: absolute;
		z-index: 100;
		right: 100px;
	}

	.shortcut-hint {
		color: #f5a623;
		white-space: nowrap;
	}

	.fjd-inline {
		cursor: pointer;
		white-space: nowrap;
		line-height: 32px;

		.fjd-count {
			width: 42px;
			height: 28px;
			text-align: center;
			border: 1px solid #d9d9d9;
			border-radius: 3px;
			margin: 0 4px;
			color: #333;
		}

		.fjd-clip {
			margin-left: 4px;
			color: #409eff;
			font-size: 15px;

			&.has-att {
				color: #52c41a;
			}
		}
	}

	.att-panel {
		padding: 0;

		.att-panel-head {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 8px 12px;
			border-bottom: 1px solid #eee;
			font-weight: bold;

			.att-upload {
				font-weight: normal;
				cursor: pointer;
				color: #409eff;

				&:hover {
					color: #1890ff;
				}
			}
		}

		.att-panel-list {
			max-height: 220px;
			overflow-y: auto;
			margin: 0;

			li {
				display: flex;
				align-items: center;
				padding: 6px 12px;
				border-bottom: 1px solid #f5f5f5;

				.att-name {
					flex: 1;
					cursor: pointer;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					margin-right: 8px;

					&:hover {
						color: #409eff;
					}
				}

				.att-size {
					color: #999;
					font-size: 12px;
					width: 46px;
					text-align: right;
				}

				.fa-trash-o {
					cursor: pointer;
					color: #bbb;
					margin-left: 10px;

					&:hover {
						color: #f56c6c;
					}
				}

				&.att-empty {
					justify-content: center;
					color: #999;
					padding: 24px;
				}
			}
		}

		.att-panel-foot {
			padding: 8px 12px;
			text-align: center;
			border-top: 1px solid #eee;
			font-size: 12px;
		}
	}

	.voucher-footer {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.footer-info {
			flex: 1;
		}

		.footer-actions {
			white-space: nowrap;
		}
	}

	.shortcut-table {
		width: 520px;

		td {
			padding: 6px 12px;
			border: 1px solid #eee;
		}

		td:nth-child(odd) {
			font-weight: bold;
			white-space: nowrap;
			width: 110px;
		}
	}

	.tpl-pane {
		width: 560px;
		margin-top: 10px;

		.tpl-list {
			margin-top: 8px;
			max-height: 260px;
			overflow-y: auto;
			border: 1px solid #eee;

			li {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 6px 10px;
				border-bottom: 1px solid #f3f3f3;

				.tpl-name {
					flex: 1;
					cursor: pointer;
				}

				.fa-trash-o {
					cursor: pointer;
					color: #999;
					margin-left: 10px;

					&:hover {
						color: #f96868;
					}
				}

				&.empty {
					justify-content: center;
					color: #999;
					padding: 16px;
				}
			}
		}
	}
</style>
